import { cn } from '@/lib/utils'

interface DescriptionProps {
  title: string
  description: string
}

export const Description: React.FC<DescriptionProps> = ({ title, description }) => {
  return (
    <div className={cn('flex items-baseline gap-3')}>
      <div className={cn('text-[12px] font-[400] leading-[18px] text-[#555]')}>{title}</div>
      <div className={cn('flex-1', 'text-[14px] font-[500] leading-[22px]', 'text-right')}>{description}</div>
    </div>
  )
}
